import { createCanvas } from './createCanvas';

const resolution = 150;

export const areAllEdgesWhite = (file: File): Promise<boolean> => {

    const check = (image: HTMLImageElement) => {
        const canvas = createCanvas(resolution, resolution);
        const ctx = canvas.getContext('2d')!;
        ctx.clearRect(0, 0, resolution, resolution);
        ctx.drawImage(image, 0, 0, resolution, resolution);
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        return !hasAlpha(data) && areEdgesWhite(data);
    };

    return new Promise((resolve, reject) => {

        const fileReader = new FileReader();

        fileReader.onload = e => {
            const image = new Image();
            image.onload = () => resolve(check(image));
            image.onerror = reject;
            image.src = e.target!.result as string;
        };

        fileReader.onerror = reject;
        fileReader.readAsDataURL(file);
    });
};

const hasAlpha = (data: Uint8ClampedArray) => {
    for (let i = 3; i < data.length; i += 4) {
        if (data[i] < 255) {
            return true;
        }
    }
    return false;
};

const areEdgesWhite = (data: Uint8ClampedArray, edgeWidth: number = 1) => {

    const top = isEdgeWhite(data, 0, resolution, 0, edgeWidth);
    const right = isEdgeWhite(data, resolution - edgeWidth, resolution, 0, resolution);
    const bottom = isEdgeWhite(data, 0, resolution, resolution - edgeWidth, resolution);
    const left = isEdgeWhite(data, 0, edgeWidth, 0, resolution);

    return top && right && bottom && left;
};

const isEdgeWhite = (
    data: Uint8ClampedArray,
    startX: number, endX: number,
    startY: number, endY: number,
    percentThreshold: number = 80
) => {

    let pixelsChecked = 0;
    let whitePixelsFound = 0;

    for (let x = startX; x < endX; x++) {
        for (let y = startY; y < endY; y++) {
            pixelsChecked++;
            if (isPixelWhite(data, x, y)) {
                whitePixelsFound++;
            }
        }
    }

    const whitePercentage = whitePixelsFound / pixelsChecked * 100;
    return whitePercentage >= percentThreshold;
};

const isPixelWhite = (
    data: Uint8ClampedArray,
    x: number,
    y: number,
    threshold: number = 253
) => {
    const [r, g, b] = getPixel(data, x, y);

    return r >= threshold
        && g >= threshold
        && b >= threshold;
};

const getPixel = (data: Uint8ClampedArray, x: number, y: number) => {

    const r = y * (resolution * 4) + x * 4;
    const g = r + 1;
    const b = r + 2;
    const a = r + 3;

    return [r, g, b, a];
};